export default __webpack_public_path__ + "static/media/android_download_icon.6b1930bf.png";